<template>
  <div class="unidades-cat-overlay">
    <div class="unidades-cat-card">
      <!-- Cerrar -->
      <button
        type="button"
        class="unidades-cat-close"
        @click="$emit('cerrar')"
      >
        ✕
      </button>

      <!-- Header -->
      <header class="unidades-cat-header">
        <div class="unidades-cat-header-main">
          <p class="unidades-cat-title">
            Filtro de categorías
          </p>
          <p class="unidades-cat-subtitle">
            Selecciona una o varias categorías para filtrar las unidades.
          </p>
        </div>
      </header>

      <!-- Chips de categorías -->
      <section class="unidades-cat-body">
        <div v-if="!categorias || !categorias.length" class="unidades-cat-empty">
          No hay categorías disponibles.
        </div>

        <div v-else class="unidades-cat-chips">
          <button
            v-for="cat in categorias"
            :key="cat"
            type="button"
            class="unidades-cat-chip"
            :class="{ 'is-selected': seleccionLocal.includes(cat) }"
            @click="toggleCategoria(cat)"
          >
            <span class="unidades-cat-chip-dot"></span>
            <span class="unidades-cat-chip-label">
              {{ cat }}
            </span>
          </button>
        </div>
      </section>

      <!-- Acciones -->
      <footer class="unidades-cat-footer">
        <button
          type="button"
          class="ios-ghost-button"
          @click="$emit('cerrar')"
        >
          Cerrar
        </button>
        <button
          type="button"
          class="ios-primary-button"
          @click="aplicar"
        >
          Aplicar filtros
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalFiltroCategorias',
  props: {
    categorias: {
      type: Array,
      default: () => [],
    },
    seleccionadas: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      seleccionLocal: [...this.seleccionadas],
    };
  },
  methods: {
    toggleCategoria(cat) {
      const index = this.seleccionLocal.indexOf(cat);
      if (index > -1) {
        this.seleccionLocal.splice(index, 1);
      } else {
        this.seleccionLocal.push(cat);
      }
    },
    aplicar() {
      this.$emit('aplicar', this.seleccionLocal);
      this.$emit('cerrar');
    },
  },
};
</script>

<style scoped>
.unidades-cat-overlay {
  position: fixed;
  inset: 0;
  z-index: 60;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem 1rem;
  background: radial-gradient(
    circle at 0 0,
    rgba(148, 163, 184, 0.35),
    rgba(15, 23, 42, 0.95)
  );
  backdrop-filter: blur(26px);
}

.unidades-cat-card {
  position: relative;
  width: 100%;
  max-width: 520px;
  border-radius: 1.6rem;
  padding: 1.3rem 1.25rem 1rem;
  background: radial-gradient(
    circle at 0 0,
    rgba(148, 163, 184, 0.35),
    rgba(15, 23, 42, 0.98)
  );
  border: 1px solid rgba(148, 163, 184, 0.7);
  box-shadow:
    0 24px 55px rgba(15, 23, 42, 0.95),
    0 0 0 1px rgba(15, 23, 42, 0.9);
  display: flex;
  flex-direction: column;
}

.unidades-cat-close {
  position: absolute;
  top: 0.35rem;
  right: 0.6rem;
  border: none;
  background: transparent;
  color: #e5e7eb;
  font-size: 0.95rem;
  cursor: pointer;
  padding: 0.2rem;
}

.unidades-cat-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.7rem;
  margin-bottom: 0.75rem;
}

.unidades-cat-header-main {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.unidades-cat-title {
  font-size: 0.9rem;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: #cbd5f5;
}

.unidades-cat-subtitle {
  font-size: 0.8rem;
  color: #94a3b8;
}

/* Body */
.unidades-cat-body {
  padding-top: 0.4rem;
  border-top: 1px solid rgba(148, 163, 184, 0.55);
}

.unidades-cat-empty {
  font-size: 0.8rem;
  color: #e5e7eb;
  padding: 0.4rem 0.1rem;
}

/* Chips */
.unidades-cat-chips {
  margin-top: 0.4rem;
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  max-height: 220px;
  overflow-y: auto;
  padding-right: 0.2rem;
}

/* Scroll fino */
.unidades-cat-chips::-webkit-scrollbar {
  width: 6px;
}
.unidades-cat-chips::-webkit-scrollbar-track {
  background: transparent;
}
.unidades-cat-chips::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.55);
  border-radius: 999px;
}

.unidades-cat-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.28rem;
  padding: 0.25rem 0.65rem;
  border-radius: 999px;
  border: 1px solid rgba(148, 163, 184, 0.7);
  background: rgba(15, 23, 42, 0.9);
  color: #e5e7eb;
  font-size: 0.8rem;
  cursor: pointer;
  transition:
    background 0.16s ease,
    border-color 0.16s ease,
    transform 0.08s ease,
    box-shadow 0.16s ease;
}

.unidades-cat-chip-dot {
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: rgba(148, 163, 184, 0.95);
}

.unidades-cat-chip-label {
  white-space: nowrap;
}

/* Estado seleccionado */
.unidades-cat-chip.is-selected {
  border-color: rgba(129, 140, 248, 0.95);
  background: radial-gradient(
    circle at 0 0,
    rgba(129, 140, 248, 0.45),
    rgba(15, 23, 42, 0.98)
  );
  box-shadow: 0 14px 32px rgba(15, 23, 42, 0.95);
}

/* Footer */
.unidades-cat-footer {
  margin-top: 0.9rem;
  display: flex;
  justify-content: flex-end;
  gap: 0.4rem;
}

/* Botones iOS glass */
.ios-primary-button,
.ios-ghost-button {
  border-radius: 999px;
  padding: 0.45rem 0.9rem;
  font-size: 0.8rem;
  border: 1px solid transparent;
  cursor: pointer;
  transition:
    background 0.16s ease,
    border-color 0.16s ease,
    transform 0.08s ease,
    box-shadow 0.16s ease;
}

.ios-primary-button {
  background: radial-gradient(
    circle at 0 0,
    rgba(129, 140, 248, 0.7),
    rgba(37, 99, 235, 1)
  );
  border-color: rgba(129, 140, 248, 0.9);
  color: #e5e7eb;
  box-shadow: 0 14px 32px rgba(37, 99, 235, 0.7);
}

.ios-primary-button:hover {
  transform: translateY(-0.5px);
  box-shadow: 0 18px 38px rgba(37, 99, 235, 0.9);
}

.ios-ghost-button {
  background: rgba(15, 23, 42, 0.9);
  border-color: rgba(148, 163, 184, 0.7);
  color: #e5e7eb;
}

.ios-ghost-button:hover {
  background: rgba(15, 23, 42, 1);
}

/* Responsive */
@media (max-width: 640px) {
  .unidades-cat-card {
    padding-inline: 1rem;
  }
}
</style>
